import axios from 'axios';
import { API_BASE } from '../config';


const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

// ایجاد صفحه جدید
export const createPage = async (data) => {
  try {
    const res = await axios.post(`${API_BASE}pages`, data, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ایجاد صفحه:', err);
    throw new Error(err.response?.data?.message || 'ایجاد صفحه با خطا مواجه شد.');
  }
};

// ویرایش صفحه موجود
export const updatePage = async (id, data) => {
  try {
    const res = await axios.put(`${API_BASE}pages/${id}`, data, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در ویرایش صفحه:', err);
    throw new Error(err.response?.data?.message || 'ویرایش صفحه با خطا مواجه شد.');
  }
};

// حذف صفحه
export const deletePage = async (id) => {
  try {
    const res = await axios.delete(`${API_BASE}pages/${id}`, authHeaders());
    return res.data;
  } catch (err) {
    console.error('خطا در حذف صفحه:', err);
    throw new Error(err.response?.data?.message || 'حذف صفحه با خطا مواجه شد.');
  }
};
